import Service from "../Service";
const resource = "TrsBudgetAlteration/";

export default {
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    save(cmp, requestID) {
        return Service.post(resource + "save", cmp, {
            params: { requestID },
        });
    },

};